<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="material-component flex flex-col flex-auto items-center w-full full-height min-w-0 bg-gray-200 dark:bg-card">
    <h1>Trang không tồn tại</h1>
    <a href="http://10.124.2.181:4200/survey-force?uuid=5f56c317-c242-17e6-9ff8-aa9e071a2e52&app_theme=OMRE&is_quiz_widget=false&is_instance=true&is_banner=false">xxx</a>
</div>
